import React, { FC } from 'react'
import Trans from 'next-translate/Trans'
import { AnchorLink } from 'components/ui'
import { Login } from 'config/constants'
import { Text } from '@mantine/core'
import { TextProps } from '@mantine/core/lib/Text/Text'

type Props = {
  align?: TextProps['align']
}

const Footer: FC<Props> = ({ align = 'center' }) => {
  return (
    <Text size="sm" align={align}>
      <Trans
        i18nKey="user:signupHasAccount"
        components={{
          component: <AnchorLink href={Login} />,
        }}
      />
    </Text>
  )
}

export default Footer
